/* eslint-disable no-template-curly-in-string */
// eslint-disable-next-line
import React, { useCallback, useEffect } from 'react';

import {
  AuthActions,
  selectAllEntitiesWithPlaceHolder,
  selectAuthError,
  selectUserEntity,
} from 'store/modules/auth';
import { Formik, FormikHelpers as FormikActions } from 'formik';

import { ChannelType, Entity } from 'core/entities';
import FirstImageLogin from 'assets/images/login-img-firstpage.png';
import Grid from '@material-ui/core/Grid';
import Layout from 'components/Layout';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Yup from 'config/yup-locale';
import { useAppDispatch } from 'store';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dictionary from 'utils/dictionary';
import { useGetSellerRole, useUserRole } from 'core/auth/hooks';
import { Roles } from 'core/auth';
import LoginForm, { LoginFormValues } from './LoginForm';
import useStyles from './Login.styles';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('El usuario es requerido')
    .max(30)
    .test(
      'No spaces allowed at first',
      'Ingrese un caracter válido',
      (value) => {
        const regex = new RegExp(/^(\s+|\s+)$/g);
        return !regex.test(value);
      }
    ),
  password: Yup.string()
    .required('El password es requerido')
    .max(20)
    .min(8, 'El password debe contener al menos ${min} caracteres'),
});

type Props = {};

const Login: React.FC<Props> = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const authEntities = useSelector(selectAllEntitiesWithPlaceHolder);
  const authError = useSelector(selectAuthError);
  const selectedEntity = useSelector(selectUserEntity);
  const history = useHistory();
  const sellerRole = useGetSellerRole([
    Roles.FIJASTH_PY_VENTAS,
    Roles.FIJASTH_PY_EXCEPCION,
  ]);
  const isSellerRole = useUserRole([sellerRole]);

  const initialFormValues: LoginFormValues = { name: '', password: '' };

  const isExternalAgent = (entities: Entity[]) => {
    return entities.some((ent) => ent?.channelType === ChannelType.Indirect);
  };

  const dispatchSelectedEntity = (entities: Entity[]) => {
    const defaultEnt = entities.find((ent) => !!ent?.isEmployee === false);
    dispatch(
      AuthActions.selectEntity(defaultEnt ? defaultEnt.id : entities[0].id)
    );
  };

  useEffect(() => {
    if (isExternalAgent(authEntities)) {
      history.push('/entities');
    } else if (selectedEntity) {
      if (isSellerRole) {
        history.push('/dashboard');
      } else {
        history.push('/claro-tv');
      }
    } else {
      dispatchSelectedEntity(authEntities);
    }
    // eslint-disable-next-line
  }, [selectedEntity, history, authEntities]);

  const handleLogin = useCallback(
    (values: LoginFormValues, actions: FormikActions<LoginFormValues>) => {
      const loginParams = {
        username: values.name.toUpperCase(),
        password: values.password,
      };
      dispatch(AuthActions.login(loginParams));
    },
    [dispatch]
  );

  const onFormValueChanged = useCallback(() => {
    if (authError) {
      dispatch(AuthActions.clearError());
    }
  }, [dispatch, authError]);

  return (
    <Layout background={false}>
      <Paper className={classes.paper}>
        <Grid container spacing={0}>
          <Grid item className={classes.grid} xs={12} sm={6}>
            <Typography className={classes.title} variant="h5" component="h1">
              {dictionary.login_title}
            </Typography>
            <Typography
              className={classes.subtitle}
              variant="caption"
              component="h2"
            >
              {dictionary.login_subtitle}
            </Typography>

            <Formik
              initialValues={initialFormValues}
              validationSchema={validationSchema}
              onSubmit={handleLogin}
            >
              <LoginForm
                serverError={authError}
                onFormValueChanged={onFormValueChanged}
              />
            </Formik>
          </Grid>
          <Grid className={classes.grid2} item xs={12} sm={6}>
            <img
              className={classes.imagen}
              alt="complex"
              src={FirstImageLogin}
            />
          </Grid>
        </Grid>
      </Paper>
    </Layout>
  );
};

export default Login;
